module.exports = __webpack_public_path__ + "img/star_struck.b1deb892.gif";